import React from "react";
import { InstagramLogo, EnvelopeSimple, XLogo } from "@phosphor-icons/react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_exfoliating-bars/artifacts/xh2ysc0y_bd6a90e97_simplelogo.png";

export default function Footer() {
  return (
    <footer
      className="py-20 lg:py-24"
      style={{ backgroundColor: '#1A1A1A' }}
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-16 mb-16">
          {/* Brand */}
          <div className="md:col-span-5">
            <img src={LOGO_URL} alt="Dermasand" className="h-20 w-auto mb-6" />
            <p className="font-body text-sm leading-relaxed max-w-sm" style={{ color: 'rgba(248,246,240,0.6)' }}>
              Bar soap made with activated charcoal and real beach sand.
              The deepest clean your skin has ever felt. $8 per bar, shipped free.
            </p>
          </div>

          {/* Links */}
          <div className="md:col-span-3">
            <h4 className="font-accent text-xs tracking-[0.25em] uppercase mb-6" style={{ color: 'rgba(248,246,240,0.4)' }}>
              Quick Links
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Products", href: "#products" },
                { label: "Our Story", href: "#story" },
                { label: "Reviews", href: "#reviews" },
                { label: "Feedback", href: "#feedback" },
                { label: "FAQ", href: "#faq" },
              ].map(link => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="font-body text-sm transition-colors duration-200"
                    style={{ color: 'rgba(248,246,240,0.6)' }}
                    onMouseEnter={(e) => e.target.style.color = '#FF5A36'}
                    onMouseLeave={(e) => e.target.style.color = 'rgba(248,246,240,0.6)'}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="font-accent text-xs tracking-[0.25em] uppercase mb-6" style={{ color: 'rgba(248,246,240,0.4)' }}>
              Connect
            </h4>
            <div className="flex gap-4 mb-6">
              <a
                href="https://instagram.com/dermasandsoap"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border transition-colors duration-200 hover:border-[#FF5A36] hover:text-[#FF5A36]"
                style={{ borderColor: 'rgba(248,246,240,0.2)', color: 'rgba(248,246,240,0.6)' }}
                data-testid="footer-instagram"
              >
                <InstagramLogo size={18} weight="regular" />
              </a>
              <a
                href="https://x.com/dermasand"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border transition-colors duration-200 hover:border-[#FF5A36] hover:text-[#FF5A36]"
                style={{ borderColor: 'rgba(248,246,240,0.2)', color: 'rgba(248,246,240,0.6)' }}
                data-testid="footer-tiktok"
              >
                <XLogo size={18} weight="regular" />
              </a>
              <a
                href="mailto:dermasandsoap@gmail.com"
                className="w-10 h-10 flex items-center justify-center border transition-colors duration-200 hover:border-[#FF5A36] hover:text-[#FF5A36]"
                style={{ borderColor: 'rgba(248,246,240,0.2)', color: 'rgba(248,246,240,0.6)' }}
                data-testid="footer-email"
              >
                <EnvelopeSimple size={18} weight="regular" />
              </a>
            </div>
            <p className="font-body text-sm" style={{ color: 'rgba(248,246,240,0.4)' }}>
              dermasandsoap@gmail.com
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t pt-8 flex flex-col sm:flex-row items-center justify-between gap-4" style={{ borderColor: 'rgba(240,237,229,0.1)' }}>
          <p className="font-body text-xs" style={{ color: 'rgba(248,246,240,0.3)' }}>
            &copy; {new Date().getFullYear()} Dermasand. All rights reserved.
          </p>
          <p className="font-heading text-2xl sm:text-3xl font-light italic tracking-tight" style={{ color: 'rgba(248,246,240,0.08)' }}>
            dermasandsoap.com
          </p>
        </div>
      </div>
    </footer>
  );
}
